module.exports = __webpack_public_path__ + "media/images/contest-label-center@3x-28c4945e05c4ed117ba5292bf886ae3f.png";